export const translations = {
  limparFiltro: {
    pt: 'Limpar Filtro',
    en: 'Clear Filter',
    de: 'Filter zurücksetzen',
    es: 'Filtro limpio',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'Abbrechen',
    es: 'Cancelar',
  },
  filtrar: {
    pt: 'Filtrar',
    en: 'Filter',
    de: 'Filtern',
    es: 'Filtrar',
  },
  rtv: {
    pt: "Código RTV",
    en: "RTV Code",
    de: "RTV-Code",
    es: "Código RTV",
  },
  rtv_gr: {
    pt: "RTV/GR",
    en: "RTV/GR",
    de: "RTV/GR",
    es: "RTV/GR",
  },
  regional: {
    pt: "Regional",
    en: "Regional",
    de: "Regional",
    es: "Regional",
  },
  selecione: {
    pt: 'Selecione...',
    en: 'Select...',
    de: 'Wählen Sie...',
    es: 'Seleccione...',
  },
};
